import React, { useEffect } from "react";
import { Box, TextField } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import moment from "moment-timezone";
/**========================================================================
 * *                                Props
 *          name =input name
 *          setFieldValue=formik setFieldValue
 *          label= input label
 *          value=data value ||change date value
 *
 *
 *
 *========================================================================**/
function DateAndTimePicker(props) {

  const handleChange = (newValue) => {
    const formattedValue = moment
      .tz(newValue._d, "Asia/Tehran")
      .locale("en")
      .format("YYYY-MM-DDTHH:mm");
      
    props.setFieldValue(props.name, formattedValue);
  };
  return (
    <Box sx={{padding:"8px"}}>
      <DateTimePicker
      disableMaskedInput
      inputFormat="jYYYY-jMM-jDD HH:mm"
      label={props.label}
      disabled={props.disabled ? true : false}
      value={props.value ? props.value : null}
      onChange={handleChange}
      renderInput={(params) => (
        <TextField
          fullWidth
          {...params}
          sx={{
            "& .MuiOutlinedInput-input": {
              padding: "9px",
              borderRadius: "8px",
            },
          }}
        />
      )}
    />
    </Box>
  );
}

export default DateAndTimePicker;
